export default "__VITE_ASSET__19958534__"